import React from 'react';
import { Redirect } from 'react-router-dom';
import { AppBar, Toolbar, Container, IconButton, Typography, Card } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MediaList from '../../components/MediaList/MediaList';
import MediaPlayerDialog from '../../components/MediaPlayer/MediaPlayerDialog';
import useMediaOpener from '../../components/MediaPlayer/useMediaOpener';

const handleBack = props => {
    props.history.goBack()
}

const readStoredChapter = () => {
    try {
        return JSON.parse(localStorage.getItem('chapter'));
    } catch (error) {
        console.error('[DetailPage] Capítulo inválido no localStorage:', error);
        return null;
    }
};

const DetailPage = props => {

    const chapter = readStoredChapter();

    const { playingMedia, openMedia, closeMedia } = useMediaOpener();

    // Acesso direto a /detail (refresh, link salvo, storage limpo): volta pra Home.
    if (!chapter) return <Redirect to="/" />;

    return (
        <>
            <AppBar position="static" color="primary">
                <Toolbar style={{ backgroundColor: '#FFF', color: '#000', textAlign: 'left' }}>
                    <IconButton edge="start" color="inherit" aria-label="Voltar" onClick={() => handleBack(props)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <div style={{ flex: 1, minWidth: 0, marginLeft: 8 }}>
                        <Typography variant="h6" noWrap>
                            {chapter.name}
                        </Typography>
                        <Typography variant="caption" component="p" noWrap>
                            {chapter.description}
                        </Typography>
                    </div>
                </Toolbar>
            </AppBar>
            <Container maxWidth="md" style={{ marginTop: 24, marginBottom: 24, textAlign: 'left' }}>
                <Card>
                    <MediaList medias={chapter.medias || []} onClickMedia={openMedia} />
                </Card>
            </Container>

            <MediaPlayerDialog media={playingMedia} onClose={closeMedia} />
        </>
    );
}

export default DetailPage;
